__webpack_require__.p = "/gatsby-theme-academic/";